import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ContractInterface } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetContractUseCase implements UseCase<Observable<Transaction<ContractInterface>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(): Observable<Transaction<ContractInterface>> {
        return this.contractProvider.current().pipe(
            map((transaction) =>
                transaction.map(
                    (contract) => Transaction.success(cloneDeep(contract)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
